"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_OBJECT = exports.EMPTY_ARRAY = void 0;
exports.EMPTY_ARRAY = [];
exports.EMPTY_OBJECT = {};
//# sourceMappingURL=base.js.map